__turbopack_context__.v({
  "message": "Vasx-a_message",
});
